import { render, staticRenderFns } from "./SkeletonContent.v2.vue?vue&type=template&id=5d95c090&scoped=true&"
import script from "./SkeletonContent.v2.vue?vue&type=script&lang=js&"
export * from "./SkeletonContent.v2.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonContent.v2.vue?vue&type=style&index=0&id=5d95c090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95c090",
  null
  
)

export default component.exports